module.exports = __webpack_public_path__ + "img/om_qr_xiaochengxu.0a26d3d6.png";